import { InfoCircleFilled, InfoCircleTwoTone } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import Colors from 'const/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface InfoButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
  tooltip?: string;
  className?: string;
  isBlue?: boolean;
}

export default function InfoButton({
  onClick,
  ariaLabel,
  tooltip,
  className = '',
  isBlue = false,
}: InfoButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      type="text"
      size="small"
      icon={
        <Tooltip title={tooltip ? t(tooltip) : t('global:info_button.title')}>
          {isBlue ? (
            <InfoCircleTwoTone
              twoToneColor={[Colors.BleuHellio, Colors.BleuCiel]}
            />
          ) : (
            <InfoCircleFilled />
          )}
        </Tooltip>
      }
      onClick={onClick}
      className={`info-button ${className}`}
      aria-label={ariaLabel ? t(ariaLabel) : t('global:info_button.aria_label')}
    />
  );
}
